import { cx } from './utils.js'

// Badge / MiniBadge (migrated off Tailwind in Wave 47u — was missed
// in the original Wave 47q sweep, which is why operators reported
// "manual" pills rendering as bare text without backgrounds).
// Styles live under .studio-badge / .studio-mini-badge in studio.css.
//
// Premium-SaaS refinement (2026-06-10): badges render with sentence-case
// labels (or natural case for acronyms like X, AI, PDF). Tone mapping
// provides consistent color across the studio.

export function Badge({ tone = 'neutral', className, children }) {
  return (
    <span className={cx('studio-badge', `tone-${tone}`, className)}>
      {children}
    </span>
  )
}

export function MiniBadge({ tone = 'muted', className, title, children }) {
  return (
    <span
      title={title}
      className={cx('studio-mini-badge', `tone-${tone}`, className)}
    >
      {children}
    </span>
  )
}
